import {useMemo} from "react";
import {get, orderBy} from "lodash";
import moment from "moment";

const getSortIteratee = (sortColumn, sortableFields) => {
  const field = sortableFields.find((field) => field.value === sortColumn);

  if (field?.type === "date") {
    return (row) => {
      const rawValue = get(row, sortColumn);
      if (!rawValue) return null;

      const value = moment(rawValue);
      return value.isValid() ? value.valueOf() : null;
    };
  }

  return sortColumn;
};

export const useSortData = (data, sortColumn, sortDirection, sortableFields = []) => {
  const sortedData = useMemo(() => {
    if (!sortColumn) return data;

    const direction = sortDirection || "asc";
    const iteratee = getSortIteratee(sortColumn, sortableFields);

    if (typeof iteratee !== "function") {
      return orderBy(data, [iteratee], [direction]);
    }

    const withKey = data.map((row) => ({row, key: iteratee(row)}));
    // Rows with no/invalid date should always sort to the bottom, regardless of direction.
    const withValue = withKey.filter(({key}) => key !== null);
    const withoutValue = withKey.filter(({key}) => key === null);

    return [
      ...orderBy(withValue, ["key"], [direction]).map(({row}) => row),
      ...withoutValue.map(({row}) => row),
    ];
  }, [data, sortColumn, sortDirection, sortableFields]);

  return sortedData;
};
